import axios from 'axios';
import { IAuth } from '../interface/interfaces';
import { listEndpointAuth } from '../constants/endpoints';


export const validateUser = (auth: IAuth) => {
    return axios.post(listEndpointAuth.validateUser, auth);
}
